module.exports = __webpack_public_path__ + "img/dev.bddd3d03.png";